import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 57px 0 0 60px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #e4e5e7;
  align-items: center;
  padding: 10px 0;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }

  .animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  .delay-1 {
    animation-delay: 0.15s;
  }

  .delay-2 {
    animation-delay: 0.25s;
  }

  .delay-3 {
    animation-delay: 0.35s;
  }

  .delay-4 {
    animation-delay: 0.45s;
  }

  .delay-5 {
    animation-delay: 0.55s;
  }

  .delay-6 {
    animation-delay: 0.65s;
  }

  .delay-7 {
    animation-delay: 0.75s;
  }

  ${mediaMaxWidth.smallDesktop} {
    padding: 0;
  }

  ${mediaMaxWidth.tablet} {
    margin: 57px 0 0 0;
  }
`;

export const Header = styled.div`
  width: 1150px;
  margin: 10px;
  padding: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fff;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  ${mediaMaxWidth.mediumDesktop} {
    width: 650px;
  }

  ${mediaMaxWidth.smallDesktop} {
    flex-direction: column;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }
`;

export const HeaderText = styled.div`
  display: flex;
  flex: 1;
  font-size: 0.9em;
  font-weight: 700;
`;

export const HeaderTextWrapper = styled.div`
  a {
    color: #333 !important;
    font-weight: 700;
    text-decoration: underline !important;

    &:hover {
      color: #333 !important;
    }
  }
`;

export const Body = styled.div`
  width: 1150px;
  display: flex;
  flex-direction: row;
  margin: 10px 0;

  ${mediaMaxWidth.mediumDesktop} {
    width: 650px;
    flex-direction: column;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    margin: 0;
  }
`;

export const Description = styled.div`
  padding: 30px;
  display: flex;
  flex: 1;
  background-color: #fff;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  border-radius: 8px;
  margin-right: 20px;

  ${mediaMaxWidth.mediumDesktop} {
    width: 650px;
    margin-right: 0;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }
`;

export const DescriptionTitle = styled.h2`
  padding: 0 0 25px 0;
  font-family: "Komet", sans-serif;
  font-size: 1.3em;
  font-weight: 900;
  color: #4f4f4f;
`;

export const Options = styled.div`
  margin-bottom: 30px;

  ${mediaMaxWidth.tablet} {
    margin-bottom: 0;
  }
`;

export const Option = styled.div`
  display: flex;
  padding: 7px 0;
  align-items: center;
`;

export const Tick = styled.img`
  width: 22px;
`;

export const OptionText = styled.div`
  font-size: 0.9em;
  padding-left: 15px;
`;

export const SmallPrint = styled.div`
  font-size: 0.8em;

  ${mediaMaxWidth.tablet} {
    display: none;
  }
`;

export const SmallPrintTitle = styled.div`
  font-weight: 700;
  margin-bottom: 7px;
`;

export const Plans = styled.div`
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  background-color: #ccc;
  flex-direction: column;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  border-radius: 8px;

  ${mediaMaxWidth.smallDesktop} {
    width: 690px;
    margin: 0 auto;
  }

  ${mediaMaxWidth.tablet} {
    display: none;
  }
`;
